import { render, staticRenderFns } from "./AddRedeemCodeDialog.vue?vue&type=template&id=23a6d4e7"
import script from "./AddRedeemCodeDialog.vue?vue&type=script&lang=js"
export * from "./AddRedeemCodeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports